import { ReactNode } from "react";

import { Flex, BoxProps } from "@chakra-ui/react";

import { TextPrimary, TextSecondary } from "theme";

import Card from "@components/Card";

interface InfoCardProps extends BoxProps {
  title?: string;
  subTitle?: string;
  children: ReactNode;
}

const InfoCard = ({ title, subTitle, children, ...rest }: InfoCardProps) => {
  return (
    <Card
      bg={{
        base: "backgroundPrimary",
        xl: "backgroundSecondary",
      }}
      {...rest}
    >
      {(title || subTitle) && (
        <Flex flexDir="column" bg="inherit">
          {title && (
            <TextPrimary
              fontWeight="600"
              fontSize={{ base: "16px", lg: "20px" }}
              lineHeight="24px"
              width="266px"
            >
              {title}
            </TextPrimary>
          )}
          {subTitle && (
            <TextSecondary
              fontSize={{ base: "12px", lg: "14px" }}
              mt={{ base: "4px", lg: "0.5rem" }}
              fontWeight="400"
            >
              {subTitle}
            </TextSecondary>
          )}
        </Flex>
      )}
      {children}
    </Card>
  );
};

export default InfoCard;
